export type PasswordRule = 'length' | 'case' | 'number' | 'symbol';

export const PASSWORD_RULES: { rule: PasswordRule; test: (password: string) => boolean }[] = [
  { rule: 'length', test: (password) => password.length >= 8 },
  { rule: 'case', test: (password) => /[a-z]/.test(password) && /[A-Z]/.test(password) },
  { rule: 'number', test: (password) => /\d/.test(password) },
  { rule: 'symbol', test: (password) => /[^A-Za-z0-9]/.test(password) },
];

export type PasswordForm = { current: string; next: string; repeat: string };
export type PasswordField = keyof PasswordForm;

/** Feilene i passordskjemaet, i samme rekkefølge som feltene */
export const passwordErrors = ({ current, next, repeat }: PasswordForm) => {
  const errors: { field: PasswordField; message: string }[] = [];
  if (!current) errors.push({ field: 'current', message: 'settings.password.errors.current' });
  if (!next) errors.push({ field: 'next', message: 'settings.password.errors.next' });
  else if (!PASSWORD_RULES.every(({ test }) => test(next))) errors.push({ field: 'next', message: 'settings.password.errors.rules' });
  else if (next === current) errors.push({ field: 'next', message: 'settings.password.errors.same' });
  if (!repeat) errors.push({ field: 'repeat', message: 'settings.password.errors.repeat' });
  else if (repeat !== next) errors.push({ field: 'repeat', message: 'settings.password.errors.mismatch' });
  return errors;
};
